/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-re-indent': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<defs><path pid="0" d="M9.143 6.12c.23.08.35.331.27.56A4.808 4.808 0 0 1 1 7.943l-.133.516a.44.44 0 0 1-.457.33L.33 8.775a.44.44 0 0 1-.33-.457l.013-.079L.4 6.73a.44.44 0 0 1 .419-.332l.074.005 1.514.228a.44.44 0 0 1-.052.876l-.08-.004-.569-.087.032.044a3.927 3.927 0 0 0 6.842-1.07.44.44 0 0 1 .562-.27zm-.15-3.667l.14-.544a.44.44 0 0 1 .866.14l-.013.079-.387 1.51a.44.44 0 0 1-.41.332l-.083-.005-1.514-.228a.44.44 0 0 1 .052-.876l.08.004.535.08-.082-.137a3.927 3.927 0 0 0-6.914.515.44.44 0 0 1-.806-.356 4.808 4.808 0 0 1 8.536-.514z" id="svgicon-icon-re-indent-a"/></defs><use _fill="#376F99" xlink:href="#svgicon-icon-re-indent-a" fill-rule="evenodd"/>'
  }
})
